/* 形状-圆形滤镜 */
import type { Canvas } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';
import ShapeFilter from './shape';

export default class ShapePlusFilter extends ShapeFilter {
    public type = AnimFilters.SHAPE_PLUS;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super(options);
    }

    protected drawShape(canvas: Canvas): void {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;
        const process = this.direction === PresetSubtype.EleCenter ? 1 - this.rate : this.rate;
        const processWidth = width * process;
        const processHeight = height * process;
        // 加号处理成三个矩形区域
        const rectX = x + ((width - processWidth) / 2);
        const rectY = y + ((height - processHeight) / 2);
        const itemHeight = (height - processHeight) / 2;
        canvas.beginPath();
        canvas.rect(x, rectY, width, processHeight);
        canvas.rect(rectX, y, processWidth, itemHeight);
        canvas.rect(rectX, height - itemHeight, processWidth, itemHeight);
        canvas.fill();
    }
}
